import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';
import LinkButton from '../../components/ui/LinkButton';
import TextOnImg from '../../components/ui/TextonImg';
import {
  heroAE,
  linkAE01,
  linkAE02,
  linkAE03,
  smallAEImg001,
  smallAEImg002,
  textAE001,
  textAE002,
  textAE003,
  textAE004,
  textAE005,
  textAE006,
} from './adaptationsExtensions-copy';

const AdaptationsExtensions = () => {
  return (
    <main className="relative max-w-screen-kia mx-auto">
      <TextOnImg {...heroAE} />

      <div className="w-full h-auto mx-auto">
        <section>
          <m.div
            initial="hidden"
            whileInView="visible"
            variants={containerVariants}
            viewport={viewPort}
            className="mb-16 mx-auto max-w-screen-kia-sm"
          >
            <m.p
              variants={itemVariants}
              className=" text-center font-light text-2xl px-2 mt-[28px]"
            >
              {textAE001}
            </m.p>
          </m.div>
        </section>
        <section className=" mx-auto px-6 w-full  max-w-7xl mb-7">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-3"
            secondComponentWidth="col-span-4 lg:col-span-5"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 lg:p-10 lg:pt-5"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={
              <div>
                <p>{textAE002}</p>
                
                
              </div>
            }
            secondComponent={<KIAImage {...smallAEImg001} />}
          />
        </section>
        <section className=" mx-auto px-6 w-full  max-w-7xl mb-7">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-5"
            secondComponentWidth="col-span-4 lg:col-span-3"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-5 lg:pb-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...smallAEImg002} />}
            secondComponent={
              <div className='flex flex-col justify-between h-full'>
                <p >{textAE003}</p>
                <LinkButton {...linkAE01} />
              </div>
            }
          />
        </section>
        <section>
          <m.div
            initial="hidden"
            whileInView="visible"
            variants={containerVariants}
            viewport={viewPort}
            className="mb-5 pt-6 mx-auto max-w-7xl border-t mt-20"
          >
            <m.p
              variants={itemVariants}
              className="text-start px-2 font-light text-2xl"
            >
              {textAE004}
            </m.p>
          </m.div>
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4 "
            mainBoxClassName="mx-auto w-full max-w-7xl border-b border-black/20 pb-6"
            firstComponentClassName="p-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={
              <div className='flex gap-2 h-full px-2 !text-lg'>
                <p className='!text-lg'>{textAE005}</p>
                <a
                  href={linkAE02.href}
                  target={linkAE02.target}
                  className=" underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4"
                >
                  {linkAE02.label}
                </a>
              </div>
            }
            secondComponent={
              <div className='flex gap-2 h-full px-2 !text-lg'>
                <p className='!text-lg'>{textAE006}</p>
                <a
                  href={linkAE03.href}
                  target={linkAE03.target}
                  className=" underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4"
                >
                  {linkAE03.label}
                </a>
              </div>
            }
          />
        </section>

        <Snippet page="adaptations-extensions" />
      </div>
    </main>
  );
};

export default AdaptationsExtensions;
